(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["trixnity-messenger-compose-app"] = factory();
	else
		root["trixnity-messenger-compose-app"] = factory();
})(globalThis, () => {
return 